import { useCallback, useRef, useState } from 'react'

const useLongPress = (
    onLongPress: any,
    { shouldPreventDefault = true, delay = 3000 } = {}
) => {
    const [longPressTriggered, setLongPressTriggered] = useState(false)
    const timeout = useRef()
    const target = useRef()

    const start = useCallback(
        (event) => {
            if (shouldPreventDefault && event.target) {
                event.target.addEventListener('touchend', preventDefault, {
                    passive: false,
                })
                target.current = event.target
            }
            // @ts-ignore
            timeout.current = setTimeout(() => {
                onLongPress(event)
                setLongPressTriggered(true)
            }, 3000)
        },
        [onLongPress, delay, shouldPreventDefault]
    )

    return {
        onMouseDown: (e: any) => start(e),
        onTouchStart: (e: any) => start(e),
    }
}

const isTouchEvent = (event: any) => {
    return 'touches' in event
}

const preventDefault = (event: any) => {
    if (!isTouchEvent(event)) return

    if (event.touches.length < 2 && event.preventDefault) {
        event.preventDefault()
    }
}

export default useLongPress
